import collapseToggleComponentUrl from './collapseToggleComponent.html';

export default {
  templateUrl: collapseToggleComponentUrl,
  controllerAs: 'ctrl',
  bindings: {
    onToggle: '&',
    isCollapsed: '<',
  },
};
